import { GatsbyBrowser } from "gatsby";
import React from "react";

import { CaptchaProvider } from "./src/captcha/captcha-provider";

export const sharedWrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  return <CaptchaProvider>{element}</CaptchaProvider>;
};
